/**
 * is cell selected
 * relate style is src/app/components/dm-grid/dm-grid.custom.style.scss line: 179
 */
export const CELL_SELECTED_CLASS = 'ag-cell-selected';
export const NO_SELECTED_BG_CLASS = 'no-selected-bg';
